/** @format */

import React, { Fragment, useState } from 'react';

import Canvas from './Canvas';
import Button from './Button';

const MonsterBox = () => {
	const [click, setClick] = useState(true);

	return (
		<Fragment>
			<div className='canvas-multi'>
				<div className='canvas-multi-box'>
					<Canvas setClick={setClick} click={click} />
					<Canvas setClick={setClick} click={click} />
					<Canvas setClick={setClick} click={click} />
                    <Canvas setClick={setClick} click={click} />
                    <Canvas setClick={setClick} click={click} />
                    <Canvas setClick={setClick} click={click} />
				</div>
				<div className='canvas-multi-button'>
					<Button click={setClick} />
				</div>
			</div>
		</Fragment>
	);
};

export default MonsterBox;
